/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

// Impossible to find import for now
import { Translations } from '@aws-amplify/ui-components';

export const i18nStrings = {
	// Amplify UI
	[Translations.NO_ACCOUNT_TEXT]: 'Non hai un account?',
	[Translations.RESET_YOUR_PASSWORD]: 'Reimposta la password',
	[Translations.NEW_PASSWORD_LABEL]: 'Nuova password',
	[Translations.NEW_PASSWORD_PLACEHOLDER]: 'Inserisci la tua nuova password',
	[Translations.CREATE_ACCOUNT_TEXT]: 'Crea un account',
	[Translations.FORGOT_PASSWORD_TEXT]: 'Hai dimenticato la password?',
	[Translations.RESET_PASSWORD_TEXT]: 'Reimposta la password',
	[Translations.SIGN_IN_ACTION]: 'ACCEDI',
	[Translations.SIGN_IN_HEADER_TEXT]: 'Accedi al tuo account',
	[Translations.SIGN_IN_TEXT]: 'Accedi',
	[Translations.SIGN_UP_EMAIL_PLACEHOLDER]:
		'Inserisci il tuo indirizzo e-mail',
	[Translations.SIGN_UP_HAVE_ACCOUNT_TEXT]: 'Hai già un account?',
	[Translations.SIGN_UP_HEADER_TEXT]: 'Crea un account',
	[Translations.SIGN_UP_PASSWORD_PLACEHOLDER]: 'Password',
	[Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: 'CREA ACCOUNT',
	[Translations.SIGN_UP_USERNAME_PLACEHOLDER]: 'Nome utente',
	[Translations.SEND_CODE]: 'Invia codice',
	[Translations.BACK_TO_SIGN_IN]: "Torna all'accesso",
	[Translations.EMAIL_LABEL]: 'Indirizzo e-mail *',
	[Translations.EMAIL_PLACEHOLDER]: 'Inserisci il tuo indirizzo e-mail',
	[Translations.PASSWORD_LABEL]: 'Password *',
	[Translations.PASSWORD_PLACEHOLDER]: 'Inserisci la tua password',
	[Translations.PHONE_LABEL]: 'Numero di telefono',
	[Translations.PHONE_PLACEHOLDER]: 'es. 338 ...',
	[Translations.CONFIRM_SIGN_UP_CODE_LABEL]: 'Codice di conferma',
	[Translations.CONFIRM_SIGN_UP_CODE_PLACEHOLDER]: 'Inserisci il tuo codice',
	[Translations.CONFIRM_SIGN_UP_HEADER_TEXT]: 'Conferma registrazione',
	[Translations.CONFIRM_SIGN_UP_LOST_CODE]: 'Hai perso il tuo codice?',
	[Translations.CONFIRM_SIGN_UP_RESEND_CODE]: 'Invia di nuovo il codice',
	[Translations.CONFIRM_SIGN_UP_SUBMIT_BUTTON_TEXT]: 'Conferma',
	[Translations.CODE_LABEL]: 'Codice di verifica',
	[Translations.CODE_PLACEHOLDER]: 'Inserisci il codice',
	[Translations.SIGN_OUT]: 'Esci',
	[Translations.SIGN_UP]: 'Registrati',

	// Translate Amplify Messages
	'Username cannot be empty': 'Il nome utente non può essere lasciato vuoto',
	'User does not exist.': "L'utente non esiste",
	'An account with the given email already exists.':
		'Esiste già un account con questo indirizzo e-mail.',
	'User is disabled.': "L'utenza risulta disabilitata.",
	'User already exists': "L'utenza esiste già.",
	'Access Token has been revoked': 'Il token di accesso risulta revocato',
	'Incorrect username or password.':
		'Nome utente (e-mail) o password errati.',
	'Network error': 'Errore di rete',
	'User is not confirmed.':
		"L'utenza (e-mail) non è ancora stata confermata.",

	'Password did not conform with policy: Password not long enough':
		'La password deve essere lunga almeno 8 caratteri',
	'Password did not conform with policy: Password must have lowercase characters':
		'La password deve contenere almeno una lettera minuscola',
	'Password did not conform with policy: Password must have uppercase characters':
		'La password deve contenere almeno una lettera maiuscola',
	'Password did not conform with policy: Password must have numeric characters':
		'La password deve contenere almeno un carattere numerico',
	'Password did not conform with policy: Password must have symbol characters':
		'La password deve contenere almeno un simbolo',

	// ### Temporary: see https://github.com/aws-amplify/amplify-js/issues/5623
	'Custom auth lambda trigger is not configured for the user pool.':
		'La password non può essere lasciata vuopta',
	// ### This may change in the future: see https://github.com/aws-amplify/amplify-js/issues/6898
	"1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6":
		'La tua password deve essere lunga almeno 6 caratteri',

	// ./components/LandingPage/LandingPage.js
	LANDING_PAGE_BUTTON_IDP_AWSSSO_LABEL: 'Accedi con AWS SSO (SAML)',
	LANDING_PAGE_BUTTON_IDP_OIDCIdentityProvider_LABEL:
		'Accedi con Demo OIDC (oauth2)',
	LANDING_PAGE_BUTTON_IDP_AMAZON_SIGNIN_LABEL: 'Accedi con Amazon',
	LANDING_PAGE_BUTTON_IDP_GOOGLE_SIGNIN_LABEL: 'Accedi con Google',
	LANDING_PAGE_BUTTON_IDP_APPLE_SIGNIN_LABEL: 'Accedi con Apple',
	LANDING_PAGE_BUTTON_IDP_FACEBOOK_SIGNIN_LABEL: 'Accedi con Facebook',
	LANDING_PAGE_BUTTON_IDP_MICROSOFT_SIGNIN_LABEL:
		'Accedi con Account Alperia (dipendenti)',
	LANDING_PAGE_DIVIDER_TEXT: 'o',
	LANDING_PAGE_CHIP_EXPAND_MORE_LABEL: 'più',
	LANDING_PAGE_CHIP_EXPAND_LESS_LABEL: 'meno',
	LANDING_PAGE_WAIT_REDIRECTION:
		"Hai effettuato l'accesso con successo, attendi il reindirizzamento...",

	// .components/LandingPage/signInContainer.js
	SIGNIN_CONTAINER_TITLE: 'Accedi',
	SIGNIN_CONTAINER_DESCRIPTION_1:
		'Effettua il primo accesso all’area clienti Alperia.',
	SIGNIN_CONTAINER_DESCRIPTION_2:
		' Le credenziali utilizzate per accedere alla precedente area clienti non sono più valide, è quindi necessario effettuare una nuova registrazione.',
	SIGNIN_CONTAINER_DESCRIPTION_3:
		'Per registrarti ti servirà il codice cliente che trovi sulla prima pagina della bolletta e il tuo codice fiscale o partita iva.	',
	SIGNIN_CONTAINER_HELPER: 'Hai bisogno di aiuto per la registrazione? ',
	SIGNIN_CONTAINER_HELPER_LINK: 'Scarica il manuale qui',
	SIGNIN_CONTAINER_HELPER_LINK_HREF:
		'https://www.alperia.eu/manualeregistrazione',
	SIGNIN_CONTAINER_LOGIN_ALPERIA_FINTEL: 'Login clienti Alperia Fintel',
	SIGNIN_CONTAINER_LOGIN_TELERISCALDAMENTO: 'Login clienti Teleriscaldamento',
	SIGNIN_CONTAINER_LOGIN_BWC: 'Login clienti BWC Energy',
	SIGNIN_CONTAINER_LOGIN_FELIX: 'Login clienti Felix Energy',
	SIGNIN_CONTAINER_LOGIN_HELP: 'Hai bisogno di aiuto? Contattaci al ',

	// ./components/Login/Login.js
	SIGNIN_EMAIL_LABEL: 'E-mail',
	SIGNIN_EMAIL_PLACEHOLDER_LABEL: 'E-mail',
	SIGNIN_PASSWORD_LABEL: 'Password',
	SIGNIN_PASSWORD_PLACEHOLDER_LABEL: 'Password',

	// ./components/Register/Register.js
	REGISTER_NAME_LABEL: 'Nome *',
	REGISTER_NAME_PLACEHOLDER_LABEL: 'Inserisci il tuo nome',
	REGISTER_SURNAME_LABEL: 'Cognome *',
	REGISTER_SURNAME_PLACEHOLDER_LABEL: 'Inserisci il tuo cognome',

	// ./components/RegisterConfirm/RegisterConfirm.js
	REGISTER_CONFIRM_EMAIL_LABEL:
		'Hai creato un account con successo. Controlla la tua e-mail per confermare la registrazione.',

	// ./pages/Dashboard/Dashboard.js
	DASHBOARD_TITLE: 'Dashboard',
	DASHBOARD_ERROR_MESSAGE: 'Si è verificato un errore',

	// ./pages/Dashboard/appTiles.js
	DASHBOARD_APPTILES_BTN_OPEN: 'Apri',
	DASHBOARD_APPTILES_LOGO: 'Logo',

	// ./pages/ErrorPage/ErrorPage.js
	ERROR_PAGE_MESSAGE: 'Ops - Pagina non trovata',

	// ./pages/Settings/Settings.js
	SETTINGS_TITLE: 'Profilo',

	// ./pages/Settings/content.js
	SETTINGS_CONTENT_TAB_SIGNIN_LABEL: 'INFORMAZIONI DI ACCESSO',
	SETTINGS_CONTENT_TAB_USER_DATA_LABEL: 'DATI UTENTE',
	SETTINGS_CONTENT_TAB_DEVICE_DATA_LABEL: 'DATI DISPOSITIVO',
	SETTINGS_CONTENT_TAB_MFA_DATA_LABEL: 'DATI MFA',

	// ./pages/Settings/tabDeviceData.js
	TAB_DEVICE_DATA_LABEL: 'DATI DISPOSITIVO',
	TAB_DEVICE_DATA_CHIP_CURRENT_LABEL: 'Questo',
	TAB_DEVICE_DATA_TEXTFIELD_STATUS_LABEL: 'Stato',
	TAB_DEVICE_DATA_TEXTFIELD_NAME_LABEL: 'Nome',
	TAB_DEVICE_DATA_TEXTFIELD_LAST_IP_LABEL: 'Ultimo indirizzo IP utilizzato',
	TAB_DEVICE_DATA_TEXTFIELD_LAST_USED_LABEL:
		"Dispositivo utilizzato per l'ultima volta il",
	TAB_DEVICE_DATA_TEXTFIELD_LAST_MODIFIED_LABEL:
		"Dispositivo modificato per l'ultima volta il",
	TAB_DEVICE_DATA_TEXTFIELD_CREATED_LABEL: 'Voce del dispositivo creata il',
	TAB_DEVICE_DATA_BUTTON_REMEMBER_DEVICE_LABEL: 'Ricorda Dispositivo',
	TAB_DEVICE_DATA_BUTTON_FORGET_DEVICE_LABEL: 'Dimentica Dispositivo',
	TAB_DEVICE_DATA_REMEMBER_DEVICE_MESSAGE:
		'Dispositivo memorizzato con successo',
	TAB_DEVICE_DATA_FORGET_DEVICE_MESSAGE:
		'Dispositivo dimenticato con successo',
	TAB_DEVICE_DATA_MESSAGE_EROR: 'Si è verificato un errore',

	// ./pages/Settings/tabMfaData.js
	TAB_MFA_DATA_LABEL: 'MFA',
	TAB_MFA_DATA_SELECT_MFA_TYPE: 'Configura il tuo tipo MFA preferito',
	TAB_MFA_DATA_SELECT_TOTP: 'TOTP',
	TAB_MFA_DATA_SELECT_SMS: 'SMS',
	TAB_MFA_DATA_SELECT_SMS_NOT_VERIFIED:
		'SMS (verifica prima il tuo numero di telefono)',
	TAB_MFA_DATA_SELECT_NO_MFA: 'Nessun MFA',
	TAB_MFA_DATA_CHANGE_BUTTON_LABEL: 'Cambia',
	TAB_MFA_DATA_SAVE_BUTTON_LABEL: 'Salva',
	TAB_MFA_DATA_CANCEL_BUTTON_LABEL: 'Annulla',
	TAB_MFA_DATA_MESSAGE_EROR: 'Si è verificato un errore',
	TAB_MFA_DATA_MESSAGE_SET_MFATYPE_SUCCESS:
		'Impostazione del tipo MFA riuscita',
	TAB_MFA_DATA_MESSAGE_VERIFY_TOTP_TOKEN_SUCCESS:
		'Configurazione di TOTP riuscita',

	// ./pages/Settings/tabSignInData.js
	TAB_SIGNIN_DATA_LABEL: 'INFORMAZIONI DI ACCESSO',
	TAB_SIGNIN_DATA_USERNAME_INPUT_LABEL: 'Nome Utente',
	TAB_SIGNIN_DATA_EMAIL_INPUT_LABEL: 'Email',
	TAB_SIGNIN_DATA_PHONENUMBER_INPUT_LABEL: 'Numero di Telefono',
	TAB_SIGNIN_DATA_CHIP_VERIFIED_LABEL: 'verificato',
	TAB_SIGNIN_DATA_CHIP_UNVERIFIED_LABEL: 'non verificato',
	TAB_SIGNIN_DATA_CANCEL_BUTTON_LABEL: 'Annulla',
	TAB_SIGNIN_DATA_SAVE_BUTTON_LABEL: 'Salva',
	TAB_SIGNIN_DATA_CHANGE_PASSWORD_LABEL: 'Cambia Password',
	TAB_SIGNIN_DATA_MESSAGE_EROR: 'Si è verificato un errore',
	TAB_SIGNIN_DATA_MESSAGE_UPDATE_ATTRIBUTE_SUCCESS:
		"L'aggiornamento è avvenuto con successo",
	TAB_SIGNIN_DATA_MESSAGE_UPDATE_ATTRIBUTE_VERIFYCATION_REQUEST:
		'Si prega di verificare le modifiche',
	TAB_SIGNIN_DATA_MESSAGE_PASSWORD_CHANGE_SUCCESS:
		'La password è stata impostata con successo',
	TAB_SIGNIN_DATA_MESSAGE_VERIFY_ATTRIBUTE_MESSAGE_SUCCESS:
		'La verifica è stata completata con successo',
	TAB_SIGNIN_DATA_MESSAGE_EMAIL_VALIDATION_ERROR:
		'Indirizzo email non valido',
	TAB_SIGNIN_DATA_MESSAGE_PHONE_NUMBER_VALIDATION_ERROR:
		'Numero di telefono non valido. Un numero di telefono può contenere solo il segno + e cifre',

	// ./pages/Settings/tabUserData.js
	TAB_USER_DATA_LABEL: 'DATI UTENTE',
	TAB_USER_DATA_TEXTFIELD_GIVEN_NAME_LABEL: 'Nome',
	TAB_USER_DATA_TEXTFIELD_FAMILY_NAME_LABEL: 'Cognome',
	TAB_USER_DATA_TEXTFIELD_ADDRESS_LABEL: 'Indirizzo',
	TAB_USER_DATA_TEXTFIELD_BIRTHDATE_LABEL: 'Data di Nascita',
	TAB_USER_DATA_TEXTFIELD_GENDER_LABEL: 'Genere',
	TAB_USER_DATA_TEXTFIELD_CUSTOM_NEWSLETTER_LABEL: 'Newsletter',
	TAB_USER_DATA_SELECT_GENDER_0: '<Seleziona>',
	TAB_USER_DATA_SELECT_GENDER_1: 'Maschio',
	TAB_USER_DATA_SELECT_GENDER_2: 'Femmina',
	TAB_USER_DATA_SELECT_GENDER_3: 'Altro',
	TAB_USER_DATA_TEXTFIELD_LANGUAGE_LABEL: 'Lingua Preferita',
	TAB_USER_DATA_SELECT_LANGUAGE_DE: 'Tedesco',
	TAB_USER_DATA_SELECT_LANGUAGE_EN: 'Inglese',
	TAB_USER_DATA_SELECT_LANGUAGE_FR: 'Francese',
	TAB_USER_DATA_SELECT_LANGUAGE_IT: 'Italiano',
	TAB_USER_DATA_SELECT_LANGUAGE_NL: 'Olandese',
	TAB_USER_DATA_CHANGE_BUTTON_LABEL: 'Cambia',
	TAB_USER_DATA_CANCEL_BUTTON_LABEL: 'Annulla',
	TAB_USER_DATA_SAVE_BUTTON_LABEL: 'Salva',
	TAB_USER_DATA_MESSAGE_EROR: 'Si è verificato un errore',
	TAB_USER_DATA_MESSAGE_UPDATE_ATTRIBUTE_SUCCESS:
		"L'aggiornamento è avvenuto con successo",

	// ./pages/TermsOfService/TermsOfService.js
	TERMS_OF_SERVICE_VERSION_ID: 1,
	TERMS_OF_SERVICE_MESSAGE_RESIGN:
		'Si prega di leggere e accettare i Termini di Servizio',
	TERMS_OF_SERVICE_MESSAGE_ACCEPTED:
		'Termini di Servizio accettati con successo.',
	TERMS_OF_SERVICE_MESSAGE_ERROR:
		'Si è verificato un errore, si prega di riprovare',
	TERMS_OF_SERVICE_MESSAGE_DECLINE:
		'I Termini di Servizio devono essere accettati.',

	// ./pages/xxx/xxx.js
	IMPRINT_TITLE: 'Impressum',

	// ./pages/TermsOfService/content.js
	TERMS_OF_SERVICE_CONTENT_VERSION_LABEL: 'Versione: 1.0.0',
	TERMS_OF_SERVICE_CONTENT_TITLE: 'Termini di Servizio',
	TERMS_OF_SERVICE_CONTENT_P1: '1. Regolamenti generali',
	TERMS_OF_SERVICE_CONTENT_P2: '2. Servizi della piattaforma',
	TERMS_OF_SERVICE_CONTENT_LOREM_IPSUM:
		'IT - Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
	TERMS_OF_SERVICE_CONTENT_BUTTON_ACCEPT_LABEL: 'Accetta',
	TERMS_OF_SERVICE_CONTENT_BUTTON_DECLINE_LABEL: 'Rifiuta',

	// ./components/AppBar/AppBar.js
	HEADER_MENU_ITEM_PROFILE: 'Profilo',
	HEADER_MENU_ITEM_DASHBOARD: 'Dashboard',
	HEADER_MENU_ITEM_LOGOUT: 'Esci',

	// ./components/ChangePasswordDialog/ChangePasswordDialog.js
	CHANGE_PASSWORD_TITLE: 'Cambia Password',
	CHANGE_PASSWORD_DESCRIPTION:
		'Inserisci la tua password attuale e quella nuova',
	CHANGE_PASSWORD_OLDPASSWORD_INPUT_LABEL: 'Vecchia Password',
	CHANGE_PASSWORD_NEWPASSWORD_INPUT_LABEL: 'Nuova Password',
	CHANGE_PASSWORD_SAVE_BUTTON_LABEL: 'Salva',
	CHANGE_PASSWORD_CANCEL_BUTTON_LABEL: 'Annulla',
	CHANGE_PASSWORD_MESSAGE_EROR: 'Si è verificato un errore',

	// ./components/LangeuageSelect/LanguageSelect.js
	LANGUAGESELECT_SELECT_LABEL: 'Lingua',

	// ./components/LogoutButton/LogoutButton.js
	LOGOUT_BUTTON_LABEL: 'Esci',

	// ./components/MfaTotpConfigDialog/MfaTotpConfigDialog.js
	MFA_TOTP_CONFIG_DIALOG_TITLE: 'Configurazione TOTP',
	MFA_TOTP_CONFIG_DIALOG_DESCRIPTION:
		"L'autenticazione a due fattori (MFA) migliora la sicurezza aggiungendo un altro metodo di autenticazione oltre a nome utente e password.",
	MFA_TOTP_CONFIG_DIALOG_STEP1_LABEL: 'Richiesta Token TOTP',
	MFA_TOTP_CONFIG_DIALOG_STEP1_DESCRIPTION:
		'Puoi utilizzare password monouso basate sul tempo (TOTP) come secondi fattori quando i tuoi utenti accedono.',
	MFA_TOTP_CONFIG_DIALOG_STEP1_BUTTON_TOKEN_REQUEST_LABEL:
		'Richiedi Token TOTP',
	MFA_TOTP_CONFIG_DIALOG_STEP2_LABEL: 'Configurazione Dispositivo TOTP',
	MFA_TOTP_CONFIG_DIALOG_STEP2_DESCRIPTION:
		'Scansiona il codice QR con il tuo dispositivo',
	MFA_TOTP_CONFIG_DIALOG_STEP3_LABEL: 'Attivazione Dispositivo TOTP',
	MFA_TOTP_CONFIG_DIALOG_STEP3_DESCRIPTION:
		"Attiva il tuo dispositivo inserendo la password monouso e clicca 'Attiva'",
	MFA_TOTP_CONFIG_DIALOG_STEP3_TEXTFIELD_VERIFY_CODE_LABEL:
		'Password Monouso',
	MFA_TOTP_CONFIG_DIALOG_STEP3_BUTTON_ACTIVATE_TOTP_LABEL: 'Attiva',
	MFA_TOTP_CONFIG_DIALOG_BUTTON_NEXT_LABEL: 'Avanti',
	MFA_TOTP_CONFIG_DIALOG_BUTTON_BACK_LABEL: 'Indietro',
	MFA_TOTP_CONFIG_DIALOG_BUTTON_CLOSE_LABEL: 'Chiudi',
	MFA_TOTP_CONFIG_DIALOG_MESSAGE_EROR: 'Si è verificato un errore',

	// ./components/VerifyAttributeDialog/VerifyAttributeDialog.js
	VERIFY_DIALOG_TITLE: 'Verifica',
	VERIFY_DIALOG_DESCRIPTION: 'Inserisci il codice:',
	VERIFY_DIALOG_INPUT_LABEL: 'Codice',
	VERIFY_DIALOG_VERIFY_BUTTON_LABEL: 'Verifica',
	VERIFY_DIALOG_CLOSE_BUTTON_LABEL: 'Chiudi',
	VERIFY_DIALOG_MESSAGE_ERROR: 'Si è verificato un errore'
};
